import React, { Component } from 'react';
import { connect } from 'shalala';
import { Button } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';

import { useStore } from '../../../store';
import LoadingButton from '../../../facturotopia/LoadingButton';
import ResponseError from '../../../shared/responses/ResponseError';
import ResponseResult from '../../../shared/responses/ResponseResult';
import ComprobanteRequestInputTransformer from '../../comprobantes/transformers/ComprobanteRequestInputTransformer';

class PrefacturaUpsert extends Component {
  componentWillUnmount = () => {
    this.props.reset();
  }

  handleOnUpsertPrefacturaRequest = () => {
    const { data, data: { Complemento = {} } } = this.props.comprobante;

    const { nomina, id } = this.props;

    let newData = {
      ...data
    }

    if (data.TipoDeComprobante === 'Nomina') {
      newData.Complemento = {
        ...Complemento,
        Nomina: nomina
      };
    }

    let input = (new ComprobanteRequestInputTransformer()).make(newData);

    this.props.upsert(input, id);
  }

  renderError = () => {
    const { error } = this.props.prefactura;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={ error }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  renderResult = () => {
    const { result } = this.props.prefactura;

    return (
      <div className="result-container">
        <ResponseResult
          title="Prefactura guardada"
          result={ result }
          extra= {
            <>
              <Button type="button"
                onClick={ this.handleOnAction.bind(this, 'success', result.data) }
              >
                Continuar
              </Button>
            </>
          }
        />
      </div>
    );
  }

  handleOnAction = (action, data = {}) => {
    if (action === 'reset') {
      this.props.reset();

      return;
    }

    if (action === 'success') {
      this.props.history.replace('/app/prefacturas');
    }

    this.props.highlight(data);
  }

  render() {
    const { isValidData, id } = this.props;
    const { busy, result, error } = this.props.prefactura;

    return (
      <>
        { !!error && this.renderError() }

        { !!result && this.renderResult() }

        <LoadingButton
          variant="secondary"
          loading={ busy }
          disabled={ !isValidData || busy }
          onClick={ this.handleOnUpsertPrefacturaRequest }
        >
          { !!id ? (busy ? 'Procesando...' : 'Actualizar prefactura') : '' }
          { !id ? (busy ? 'Procesando...' : 'Guardar prefactura') : '' }
        </LoadingButton>
      </>
    );
  }
}

const mapState = (state) => {
  return {
    prefactura: state.app.prefacturas.upsert,
    list: state.app.prefacturas.list
  }
}

const mapActions = (actions) => {
  return {
    upsert: actions.app.prefacturas.upsert.upsert,
    reset: actions.app.prefacturas.upsert.reset,
    highlight: actions.app.prefacturas.list.highlight
  };
}

export default connect(useStore, mapState, mapActions)(withRouter(PrefacturaUpsert));
